import { saveAs } from "file-saver";

// Helper function to download Excel file from base64 data
export function downloadExcelFile(excelResult: { data: string, filename: string, contentType: string, isBase64: boolean; }) {
  if (excelResult && excelResult.data) {
    // Convert base64 to blob
    const byteCharacters = atob(excelResult.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: excelResult.contentType });

    // Save the file using FileSaver
    saveAs(blob, excelResult.filename);
  }
}